import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useChatWidget } from '../../contexts/ChatWidgetContext';

/**
 * Renders a Header nav item that opens the chat panel when clicked.
 * Use inside Header (or any child of ChatWidgetProvider).
 */
export default function ChatHeaderTrigger() {
  const { openPanel } = useChatWidget();

  return (
    <NavDropdown.Item
      eventKey="chat"
      onClick={() => openPanel('header')}
    >
      Chat
    </NavDropdown.Item>
  );
}
